import styled from "styled-components";
import TotleScore from "./TotleScore";
import NumberSelector from "./NumberSelector";
import RoleDice from "./RoleDice";
import { useState } from "react";
const GamePlay = () => {
  const [selectdNumber, setSelectedNumber] = useState();
  const [currentDice, setCurrentDice] = useState(1);
  const [score, setScore] = useState(0);
  const [error, setError] = useState("");

  const roleDice = () => {
    if (!selectdNumber) {
      setError("You Have Not Selected any Number");
      return;
    }
    const generatedRandomNumber = (min, max) => {
      return Math.floor(Math.random() * (max - min) + min);
    };
    const randomNumber = generatedRandomNumber(1, 7);
    setCurrentDice((prev)=>randomNumber);
    console.log(selectdNumber + " " + currentDice);
    if (selectdNumber === randomNumber) {
      console.log("equal");
      setScore((prev) => prev + randomNumber);
    } else {
      setScore((prev) => prev - 2);
    }
    setSelectedNumber();
  };
  return (
    <MainContainer>
      <div className="top_section">
        <TotleScore score={score} />
        <NumberSelector
          selectdNumber={selectdNumber}
          setSelectedNumber={setSelectedNumber}
          setError={setError}
          error={error}
        />
      </div>
      <RoleDice
        currentDice={currentDice}
        roleDice={roleDice}
        setScore={setScore}
      />
    </MainContainer>
  );
};
export default GamePlay;
const MainContainer = styled.div`
  padding-top: 20px;
  .top_section {
    display: flex;
    justify-content: space-between;
  }
`;
